import { Component, EventEmitter, OnInit, Output, ChangeDetectionStrategy } from '@angular/core';
import { BaseComponent } from 'src/app/core/base-classes/base/base.component';

@Component({
    selector: 'fury-config-panel-toggle',
    templateUrl: './config-panel-toggle.component.html',
    styleUrls: ['./config-panel-toggle.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ConfigPanelToggleComponent extends BaseComponent implements OnInit {

  @Output() public openConfig = new EventEmitter();

  constructor() {
    super();
  }

  ngOnInit() {
  }

}
